import React from 'react';

interface ICartIconProps {
	size?: string;
}

export const CartIcon = ({ size = '24' }: ICartIconProps) => {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.87231 7.03553C8.92626 5.79544 9.29136 4.71758 9.81263 3.9554C10.3811 3.12418 11.0652 2.75 11.7003 2.75C12.3362 2.75 13.0234 3.1251 13.5946 3.95697C14.1182 4.71932 14.4852 5.79672 14.5395 7.03553H8.87231ZM6.87085 7.03553C6.92565 5.43402 7.39125 3.95301 8.16179 2.82636C8.98032 1.62953 10.2137 0.75 11.7003 0.75C13.186 0.75 14.4219 1.6286 15.2433 2.82479C16.0169 3.95126 16.4858 5.43273 16.541 7.03553H22.1724C22.484 7.03553 22.7779 7.18085 22.9671 7.42854C23.1563 7.67623 23.2191 7.99796 23.1371 8.29865L19.7334 20.779C19.6148 21.214 19.2196 21.5159 18.7686 21.5159H5.15374C4.70278 21.5159 4.30762 21.214 4.18897 20.779L0.785245 8.29865C0.703239 7.99796 0.766119 7.67623 0.955302 7.42854C1.14449 7.18085 1.43834 7.03553 1.75001 7.03553H6.87085ZM5.91753 19.5159L3.05926 9.03553H20.8631L18.0048 19.5159H5.91753Z"
				fill="#3D3D3D"
			/>
		</svg>
	);
};
